export const CONTENT_VERSION_HEADER = 'x-quince-content-version'
